import { useEffect, useState, useCallback } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Award } from "lucide-react";

// Certificats Petits Samouraïs décernés mais pas encore remis en main propre au dojo.
export function RemisesPanel() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(true);
  const load = useCallback(async () => { try { const r = await api.get("/samourais/carnet/remises"); setData(r.data); } catch { /* silencieux */ } }, []);
  useEffect(() => { load(); }, [load]);
  const mark = async (x) => {
    try {
      await api.post(`/samourais/sessions/${x.session_id}/enrollment/${x.eid}/certificate/${x.stage_id}/handed`, { handed: true });
      toast.success(`Remis à ${x.child_name} ✓`); load();
    } catch { toast.error("Erreur"); }
  };
  if (!data) return null;
  return (
    <div className="mb-6 rounded-2xl border border-amber-500/30 bg-amber-500/5" data-testid="ps-remises-panel">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-4 py-3 text-left" data-testid="ps-remises-toggle">
        <div className="flex items-center gap-2 font-semibold"><Award className="w-4 h-4 text-amber-400" /> Certificats à remettre au prochain cours
          <span className={`text-[10px] px-2 py-0.5 rounded-full ${data.pending.length ? "bg-amber-500/25 text-amber-200" : "bg-emerald-500/20 text-emerald-300"}`} data-testid="ps-remises-count">{data.pending.length} à remettre · {data.handed.length} remis</span>
        </div>
        <span className="text-xs text-zinc-400">{open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div className="border-t border-white/10 p-4 space-y-1.5">
          {data.pending.length === 0 && <p className="text-sm text-zinc-400 italic">Tous les certificats décernés ont été remis 🎉</p>}
          {data.pending.map((x) => (
            <div key={x.eid + x.stage_id} className="flex flex-wrap items-center justify-between gap-2 rounded-lg bg-white/5 px-3 py-2 text-sm" data-testid={`ps-remise-${x.eid}-${x.stage_id}`}>
              <div><img src={`/badges/${x.stage_id}.png`} alt="" className="inline w-6 h-6 rounded-full mr-2 align-middle" /><b>{x.child_name}</b> — {x.label} <span className="text-xs text-zinc-400">· décerné le {x.date}{x.sent_at ? " · PDF envoyé ✓" : " · PDF non envoyé"} · {x.session_title}</span></div>
              <button onClick={() => mark(x)} className="text-xs px-3 py-1 rounded bg-amber-600/80 hover:bg-amber-600 font-semibold" data-testid={`ps-remise-mark-${x.eid}-${x.stage_id}`}>✓ Remis en main propre</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
